import { render } from "./LawsuitPage.vue?vue&type=template&id=0f40dcba&scoped=true"
import script from "./LawsuitPage.vue?vue&type=script&lang=js"
export * from "./LawsuitPage.vue?vue&type=script&lang=js"

import "./LawsuitPage.vue?vue&type=style&index=0&id=0f40dcba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f40dcba"]])

export default __exports__